import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { OperationOutcome } from '../models/operation-outcome.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-rosetta-error-dialog',
    templateUrl: './rosetta-error-dialog.component.html',
    styleUrls: ['./rosetta-error-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class RosettaErrorDialogComponent {
  error = inject<RosettaErrorDialogData>(MAT_DIALOG_DATA);

  constructor() {
    console.log(this.error);
  }
}

export interface RosettaErrorDialogData {
  message: string;
  error: OperationOutcome;
}
